/* ad-gifting-variant.js — AD-CONFIG-GIFTING-STEPS-RANDOMISER.md (theme side).
 *
 * Reads the new fields the Bar Ads dashboard emits inside window.adConfigs['<key>']:
 *   page, heroCarousel, personaliseStep, sixInputs, variants[].
 *
 * • heroCarousel — a hero band of the ad's carousel assets at the top of the page (BOTH the real
 *   gifting page and /pages/build-your-box).
 * • personaliseStep / sixInputs / variants — GIFTING PAGE ONLY (.bb-page--giftpage). Ignored on
 *   /pages/build-your-box.
 * • variants[] — an in-house A/B/C page test: pick exactly ONE variant per visitor, sticky by bb_vid
 *   (hash, no extra cookie), overridable with ?ad_v=<id> for QA. Record it (journey event + a hidden
 *   _ad_variant cart property) so the dashboard can score CPA/ROAS by variant.
 *
 * Loads AFTER journey-collect.js (needs window.bbTrack) and AFTER the ad-config-*.js files (needs
 * window.adConfigs). Runs at defer time — before the below-the-fold builder is scrolled into view, so
 * the personaliseStep reorder is not visible reordering. Everything is wrapped so it can never break
 * the storefront.
 */
(function () {
  function run() {
  try {
    var GIFT_FMT = document.querySelector('.bb-page--gifting');    // message-first pages: gifting OR build-your-box
    if (!GIFT_FMT) return;
    var onGift = !!document.querySelector('.bb-page--giftpage');    // the REAL gifting page (variants/steps/inputs)

    var params = new URLSearchParams(location.search);
    var activeAd = params.get('ad');
    // bbActiveAdKey (build-your-box.liquid) applies the 24h TTL to stored keys; fall back to the raw
    // session value only if the helper is absent (never raw localStorage — that's the eternal-key bug).
    try { activeAd = activeAd || (window.bbActiveAdKey ? window.bbActiveAdKey() : sessionStorage.getItem('bb_ad')); } catch (e) {}
    if (!activeAd || !window.adConfigs || !window.adConfigs[activeAd]) return;
    var cfg = window.adConfigs[activeAd];

    // Respect the config's declared target page. bb_ad persists in sessionStorage, so a customer who
    // clicks a build-your-box ad and then wanders to /pages/gifting still has the bab config active —
    // without this gate its variants/steps/inputs ran on the WRONG page's personaliser and stamped a
    // misleading _ad_variant on gifting orders (seen on order BB19538). No declared page → legacy
    // config → behave as before.
    if (cfg.page) {
      var currentPage = onGift ? 'gifting' : 'build-your-box';
      if (cfg.page !== currentPage) return;
    }

    function bbVid() {
      try {
        var v = localStorage.getItem('bb_vid');
        if (v) return v;
      } catch (e) {}
      var m = document.cookie.match(/(?:^|;)\s*bb_vid=([^;]+)/);
      return m ? decodeURIComponent(m[1]) : '';
    }

    // ── pick exactly one variant (sticky by bb_vid; ?ad_v forces one for QA) ──
    function pickVariant(c) {
      if (!c.variants || !c.variants.length) return c;                 // flat config → itself
      var forced = params.get('ad_v');
      if (forced) {
        for (var i = 0; i < c.variants.length; i++) { if (String(c.variants[i].id) === String(forced)) return c.variants[i]; }
      }
      var vid = bbVid() || 'anon';
      var total = c.variants.reduce(function (s, v) { return s + (v.weight || 1); }, 0) || 1;
      var h = 0; for (var k = 0; k < vid.length; k++) h = (h * 31 + vid.charCodeAt(k)) >>> 0;
      var r = (h % 1000) / 1000 * total, acc = 0;
      for (var j = 0; j < c.variants.length; j++) { acc += (c.variants[j].weight || 1); if (r < acc) return c.variants[j]; }
      return c.variants[0];
    }

    var hasVariants = onGift && cfg.variants && cfg.variants.length;   // A/B split is gifting-only
    var variant = hasVariants ? pickVariant(cfg) : null;

    // Field resolution: variant value wins over the base config (variant.x ?? cfg.x).
    function pick(name) { return (variant && variant[name] != null) ? variant[name] : cfg[name]; }
    var heroOn = pick('heroCarousel');
    var personaliseStep = onGift ? pick('personaliseStep') : null;
    var initialInputs = onGift ? (Number(pick('initialInputs')) || 6) : null;   // 1 | 6 (default 6) — which view opens
    var sixInputs = onGift ? pick('sixInputs') : null;
    var singleInput = onGift ? pick('singleInput') : null;

    // ── record which variant (gifting A/B only) ──
    if (hasVariants && variant && variant.id != null) {
      // Expose the resolved variant for the journey collector's attribution (per-variant funnel).
      window.bbAdVariant = String(variant.id);
      try { sessionStorage.setItem('bb_ad_variant', String(variant.id)); } catch (e) {}
      try { if (window.bbTrack) window.bbTrack('page', 'ad_variant', String(variant.id)); } catch (e) {}
      var form = document.getElementById('bb-product-form');
      if (form && !form.querySelector('input[name="properties[_ad_variant]"]')) {
        var inp = document.createElement('input');
        inp.type = 'hidden'; inp.name = 'properties[_ad_variant]'; inp.value = String(variant.id);
        form.appendChild(inp);
      }
    }

    // ── per-variant page copy: the base cfg.headline/subtitle is already applied by bb-box.js; when the
    //    RESOLVED variant carries its own headline/subtitle (A/B different page copy), override it here.
    //    innerHTML → honours <br> (ad-config, not shopper input — same trust level as the base swap). ──
    if (variant) {
      if (variant.headline != null) { var _vt = document.querySelector('.bb-page-title'); if (_vt) _vt.innerHTML = variant.headline; }
      if (variant.subtitle != null) { var _vs = document.querySelector('.bb-page-subtitle'); if (_vs) _vs.innerHTML = variant.subtitle; }
    }

    // ── personaliseStep: slot the personalisation step into position 1|2|3, keeping size<flavours order ──
    if (onGift && (personaliseStep === 1 || personaliseStep === 2 || personaliseStep === 3)) {
      var stepSize = document.querySelector('.bb-page--giftpage .bb-step-size');
      var stepFlav = document.querySelector('.bb-page--giftpage .bb-flavour-section');
      var stepPerso = document.querySelector('.bb-page--giftpage .bb-story-section');
      var ord = personaliseStep === 1 ? { perso: 1, size: 2, flav: 3 }
              : personaliseStep === 2 ? { size: 1, perso: 2, flav: 3 }
              :                         { size: 1, flav: 2, perso: 3 };
      if (stepSize) stepSize.style.order = ord.size;
      if (stepFlav) stepFlav.style.order = ord.flav;
      if (stepPerso) stepPerso.style.order = ord.perso;
    }

    // ── heroCarousel band (both pages) ──
    if (heroOn) buildHero();

    // ── initialInputs: which view the personaliser OPENS with — 6 boxes (seeded from sixInputs) or 1
    //    box (seeded from singleInput). Both preset sets always travel; the customer's existing
    //    "make every bar unique" toggle switches 1↔6. Gifting only, default 6. ──
    if (onGift) applyInitialInputs(initialInputs, sixInputs, singleInput);

    // ---- helpers ----------------------------------------------------------

    function openPersonaliser() {
      var story = document.querySelector('.bb-page--giftpage .bb-story-section');
      var head = document.querySelector('.bb-page--giftpage .bb-story-section .bb-step-heading');
      if (story && !story.classList.contains('is-open') && head) { try { head.click(); } catch (e) {} }
    }
    // Set a field's VALUE so it renders ON THE BAR, then fire input so the personaliser commits + repaints.
    // ONLY when the field is empty → never clobber what the customer has typed.
    function fireInput(el) {
      try { el.dispatchEvent(new Event('input', { bubbles: true })); el.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
    }
    // Fill a field with a VALUE so it renders ON THE BAR — ONLY when empty (never clobber typed text).
    function seedValue(el, text) {
      if (!el || !text) return;
      if ((el.value || '').trim()) return;
      el.value = String(text).slice(0, 20);
      fireInput(el);
    }
    // The set of ad-preset strings (single + all six). Lets us tell a "carried-over preset" (safe to
    // overwrite when the customer flips 1↔6) apart from text the customer actually typed (never touch).
    var AD_SIX = null, AD_SINGLE = null;
    // Presets live on window (not a per-IIFE var): the toggle listener may call a seed fn from a different
    // IIFE than the one that bound it, so the check must read a single shared source.
    function buildPresets() {
      var P = {};
      if (AD_SINGLE && AD_SINGLE.text) P[String(AD_SINGLE.text).slice(0, 20).trim()] = 1;
      if (AD_SIX) AD_SIX.forEach(function (s) { if (s && s.text) P[String(s.text).slice(0, 20).trim()] = 1; });
      window.__bbAdPresets = P;
    }
    function isPresetOrEmpty(v) { v = (v || '').trim(); var P = window.__bbAdPresets; return !v || !!(P && P[v]); }
    // Set a field to the ad's preset, overwriting ONLY if it's empty or still holds a known preset — so a
    // mode flip swaps to the matching ad message, but a customer's own words are preserved.
    function seedOrReplace(el, text) {
      if (!el || !text) return;
      var want = String(text).slice(0, 20);
      if ((el.value || '').trim() === want) return;      // already correct
      if (!isPresetOrEmpty(el.value)) return;            // customer-typed → leave it
      el.value = want;
      fireInput(el);
    }
    // In single mode the message lives in the FIRST committed row (.mb-drow-label); #mb-first-occasion is
    // only the transient entry that commits into that row and then hides. Seed whichever is currently live,
    // retrying through the 6→1 transition.
    function seedSingle(single) {
      if (single && single.open) openPersonaliser();
      if (!single || !single.text) return;
      // Keep RE-ASSERTING through the 6→1 transition: the personaliser settles row[0] back to the six
      // preset a beat after the toggle, so a single set gets clobbered — we re-apply for ~1.8s. seedOrReplace
      // only overwrites empty/preset fields, so once the customer types their own words we stop touching it.
      var want = String(single.text).slice(0, 20), tries = 0;
      (function poll() {
        var row = document.querySelector('#mb-date-list .mb-drow-label');
        if (row && row.offsetParent) seedOrReplace(row, want);
        else {
          var fo = document.getElementById('mb-first-occasion');   // no committed row yet → seed the entry
          if (fo && fo.offsetParent && isPresetOrEmpty(fo.value)) { fo.value = want; fireInput(fo); }
        }
        if (++tries < 12) setTimeout(poll, 150);
      })();
    }
    // TRUE when the customer has already typed ANY personalisation content (messages, per-bar names,
    // single name/anecdote). Once they're engaged, the ad presets must never seed, auto-open, or flip
    // modes — the config can arrive LATE (async ad-configs fetch → bb:ad-config-loaded re-run) and a
    // mode flip clears the Names hidden props mid-purchase (order BB19538 arrived nameless that way).
    function customerEngaged() {
      var sels = ['#mb-date-list .mb-drow-label', '#mb-names-perbar .mb-bar-name', '#mb-names-perbar .mb-bar-msg',
                  '#mb-name-line', '#mb-anecdote-line', '#mb-first-occasion', '#mb-first-name'];
      for (var i = 0; i < sels.length; i++) {
        var els = document.querySelectorAll(sels[i]);
        for (var j = 0; j < els.length; j++) {
          var v = (els[j].value || '').trim();
          if (v && !isPresetOrEmpty(v)) return true;                     // ad presets themselves don't count
        }
      }
      return false;
    }
    function applyInitialInputs(n, six, single) {
      AD_SIX = six; AD_SINGLE = single; buildPresets();
      if (customerEngaged()) return;                                     // never fight typed content
      if (Number(n) === 1) seedSingle(single);                           // open with the single message box
      else if (six && six.length) seedSixInputs(six);                    // default (6): open with the six boxes
      // Publish the ad state + this instance's seed fns on window, so the (once-bound) toggle listener
      // always drives the LATEST config — the guard is on window but the closures aren't, so the listener
      // and the instance that holds the real data can be different IIFEs. window is the shared source.
      window.__bbAdState = { six: six, single: single, seedSix: seedSixInputs, seedSingle: seedSingle };
      // Re-seed the config presets when the customer flips the 1↔6 toggle, so switching shows the ad's
      // messages (single → singleInput, six → sixInputs). seedOrReplace only overwrites empty/preset
      // fields, so anything the customer typed is preserved. Bound once (guard on the module flag).
      if (!window.__bbAdToggleBound) {
        window.__bbAdToggleBound = true;
        document.addEventListener('click', function (e) {
          var opt = e.target && e.target.closest ? e.target.closest('.mb-six-opt, #mb-gift-six-btn-n') : null;
          if (!opt) return;
          // Decide from the CLICKED control (the .bb-gift-6on class lags the click, so don't read mode state).
          var toSix = opt.id === 'mb-gift-six-btn-n' || opt.getAttribute('data-six') === 'unique';
          // BUBBLE phase + same-tick seeding: the personaliser's own click handler has ALREADY built and
          // shown the rows by the time this runs, so the presets land before the next paint — the customer
          // never sees the empty "Your message" placeholder flash before the ad's line arrives (the old
          // capture-phase + 400ms delay painted the placeholder first). The seeders' internal polls remain
          // as a backstop for anything the personaliser defers.
          var st = window.__bbAdState || {};
          if (toSix) { if (st.six && st.six.length && st.seedSix) st.seedSix(st.six); }
          else if (st.single && st.seedSingle) st.seedSingle(st.single);
        }, false);
      }
    }

    // The composite set pushed to Meta (all bar images → full box → cross-section). The dashboard is
    // expected to emit it as an array on the config/variant; we read the likely field names and skip the
    // band if none is present (dormant until the generator supplies it). An optional cross-section image
    // (crossSection / crossSectionImage) is ALWAYS forced to the LAST slide — deduped if already in the
    // array — so the carousel reliably ends on the bar cross-section from the ad.
    function heroImageList() {
      var src = (variant && (variant.heroImages || variant.carousel || variant.carouselImages))
        || cfg.heroImages || cfg.carousel || cfg.carouselImages || null;
      var arr = Array.isArray(src) ? src.slice() : (typeof src === 'string' ? [src] : []);
      arr = arr.filter(function (u) { return u && typeof u === 'string'; });
      // Drop the full-box overview shot from the header carousel ON MOBILE ONLY (kept on desktop's wider
      // frame). The box is identified ONLY by an explicit boxImage/box URL tagged on the config — never
      // guessed by position (a lead-slide guess wrongly removed a bar image). No tag → nothing removed.
      // matchMedia matches the CSS breakpoint reliably pre-layout (innerWidth can read 0). Guard on
      // length>1 so a 1-image carousel is never emptied.
      var box = (variant && (variant.boxImage || variant.box)) || cfg.boxImage || cfg.box || null;
      var isMobile = !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
      if (isMobile && arr.length > 1 && box && typeof box === 'string') {
        arr = arr.filter(function (u) { return u !== box; });
      }
      var cross = (variant && (variant.crossSection || variant.crossSectionImage || variant.crossSectionImg))
        || cfg.crossSection || cfg.crossSectionImage || cfg.crossSectionImg || null;
      if (cross && typeof cross === 'string') {
        arr = arr.filter(function (u) { return u !== cross; });         // drop any earlier copy…
        arr.push(cross);                                               // …and pin it to the end
      }
      return arr.length ? arr : null;
    }

    function buildHero() {
      if (document.querySelector('.bb-ad-hero')) return;               // already built
      var imgs = heroImageList();
      if (!imgs) return;                                               // no assets supplied → no band
      var main = document.getElementById('MainContent') || document.body;

      var band = document.createElement('div');
      band.className = 'bb-ad-hero';
      band.setAttribute('aria-label', 'From your ad');

      var vp = document.createElement('div');                          // the framed viewport (one image wide)
      vp.className = 'bb-ad-hero__vp';
      var track = document.createElement('div');
      track.className = 'bb-ad-hero__track';
      // Ask the image SOURCE for the right size so the theme never downloads more pixels than the frame
      // shows: frame is <=760px wide (mobile 375-430), so 2× retina = ~800px mobile / ~1100px desktop.
      // Shopify CDN honours ?width= today; hero-assets URLs get the same hint so the dashboard can honour
      // it server-side (resize+cache there — the theme shouldn't be downscaling big originals in-page).
      var hintW = (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) ? 800 : 1100;
      function sizeHint(u, w) {
        try {
          if (/[?&]width=/.test(u)) return u;                            // already sized — leave it
          var resizable = u.indexOf('cdn.shopify.com') !== -1 || u.indexOf('/hero-assets') !== -1;
          if (!resizable) return u;
          return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
        } catch (e) { return u; }
      }
      imgs.forEach(function (u, i) {
        var slide = document.createElement('div');
        slide.className = 'bb-ad-hero__slide';
        var im = document.createElement('img');
        im.className = 'bb-ad-hero__img'; im.decoding = 'async'; im.alt = '';
        im.loading = i === 0 ? 'eager' : 'lazy';
        if (i === 0) { try { im.fetchPriority = 'high'; } catch (e) {} }   // first slide = LCP, prioritise it
        im.src = sizeHint(u, hintW);
        slide.appendChild(im);
        track.appendChild(slide);
      });
      vp.appendChild(track);

      // prev/next arrows (desktop; touch users just swipe)
      function step(dir) { track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' }); }
      var prev = document.createElement('button');
      prev.type = 'button'; prev.className = 'bb-ad-hero__nav bb-ad-hero__nav--prev'; prev.setAttribute('aria-label', 'Previous'); prev.innerHTML = '‹';
      var next = document.createElement('button');
      next.type = 'button'; next.className = 'bb-ad-hero__nav bb-ad-hero__nav--next'; next.setAttribute('aria-label', 'Next'); next.innerHTML = '›';
      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
      if (imgs.length > 1) { vp.appendChild(prev); vp.appendChild(next); }
      band.appendChild(vp);

      // dot indicators (also clickable), tracking the current slide
      var dots = document.createElement('div');
      dots.className = 'bb-ad-hero__dots';
      if (imgs.length > 1) imgs.forEach(function (u, i) {
        var d = document.createElement('button');
        d.type = 'button'; d.className = 'bb-ad-hero__dot' + (i === 0 ? ' is-on' : ''); d.setAttribute('aria-label', 'Slide ' + (i + 1));
        d.addEventListener('click', function () { var s = track.children[i]; if (s) track.scrollTo({ left: s.offsetLeft, behavior: 'smooth' }); });
        dots.appendChild(d);
      });
      band.appendChild(dots);
      var lastIdx = 0;
      track.addEventListener('scroll', function () {
        var w = track.clientWidth; if (!w) return;
        var idx = Math.round(track.scrollLeft / w);
        if (idx === lastIdx) return;                                   // only touch the DOM on a real change
        lastIdx = idx;
        var kids = dots.children;
        for (var i = 0; i < kids.length; i++) kids[i].classList.toggle('is-on', i === idx);
      }, { passive: true });

      if (!document.getElementById('bb-ad-hero-css')) {
        var st = document.createElement('style'); st.id = 'bb-ad-hero-css';
        st.textContent = '.bb-ad-hero{width:100%;padding:8px 0 4px;background:transparent}'
          + '.bb-ad-hero__vp{position:relative;width:100%;max-width:460px;margin:0 auto}'
          + '.bb-ad-hero__track{display:flex;overflow-x:auto;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;scrollbar-width:none;border-radius:14px}'
          + '.bb-ad-hero__track::-webkit-scrollbar{display:none}'
          + '.bb-ad-hero__slide{flex:0 0 100%;width:100%;scroll-snap-align:center;display:flex;align-items:center;justify-content:center}'
          + '.bb-ad-hero__img{width:100%;height:min(52vw,210px);object-fit:cover;background:transparent;border-radius:14px;display:block}'
          + '.bb-ad-hero__dots{display:flex;gap:6px;justify-content:center;margin-top:8px}'
          + '.bb-ad-hero__dot{width:7px;height:7px;border-radius:50%;border:0;padding:0;background:#8a6d3b;opacity:.35;cursor:pointer;transition:opacity .2s,transform .2s}'
          + '.bb-ad-hero__dot.is-on{opacity:1;transform:scale(1.3)}'
          + '.bb-ad-hero__nav{position:absolute;top:50%;transform:translateY(-50%);width:38px;height:38px;border-radius:50%;border:0;background:rgba(255,255,255,.82);color:#5b4a2f;font-size:24px;line-height:1;cursor:pointer;display:none;align-items:center;justify-content:center;box-shadow:0 1px 5px rgba(0,0,0,.18);z-index:2}'
          + '.bb-ad-hero__nav--prev{left:8px}.bb-ad-hero__nav--next{right:8px}'
          + '.bb-ad-hero__nav:hover{background:#fff}'
          + '@media(min-width:750px){.bb-ad-hero__vp{max-width:760px}.bb-ad-hero__vp:hover .bb-ad-hero__nav{display:flex}.bb-ad-hero__img{height:300px}}';
        document.head.appendChild(st);
      }
      main.insertBefore(band, main.firstChild);                        // a band at the very top, above the builder
    }

    // Open six-unique (if not already) so all six inputs render, then seed each bar's VALUE from sixInputs
    // so the ad's messages show ON THE BARS. seedValue only fills empty fields → never clobbers typed text.
    function seedSixInputs(list) {
      if (!list.some(function (b) { return b && b.text; })) return;
      // Only click the toggle if six-unique isn't already active (clicking an active toggle turns it OFF).
      if (!document.querySelector('.bb-gift-6on')) {
        var head = document.querySelector('.bb-page--giftpage .bb-story-section .bb-step-heading');
        var story = document.querySelector('.bb-page--giftpage .bb-story-section');
        if (story && !story.classList.contains('is-open') && head) { try { head.click(); } catch (e) {} }
        var six = document.getElementById('mb-gift-six-btn-n') || document.querySelector('.mb-six-opt[data-six="unique"]');
        if (six) { try { six.click(); } catch (e) {} }
      }
      // Keep RE-ASSERTING through the 1→6 transition: the personaliser can settle row[0] back to a
      // carried-over single preset a beat after the toggle. seedOrReplace only overwrites empty/preset
      // fields, so the customer's own words are preserved.
      var tries = 0;
      (function poll() {
        var inputs = document.querySelectorAll('#mb-date-list .mb-drow-label');
        if (inputs.length) {
          for (var i = 0; i < list.length && i < inputs.length; i++) {
            if (list[i]) seedOrReplace(inputs[i], list[i].text);      // VALUE → renders on the bar
          }
        }
        if (++tries < 14) setTimeout(poll, 150);                       // ~2s: render wait + transition re-assert
      })();
    }
  } catch (e) { /* telemetry / progressive-enhancement must never break the storefront */ }
  }
  run();
  // Re-apply if a dashboard-pushed config arrives after this first ran (build-your-box.liquid fetch block).
  // First run early-returns when the config isn't present yet; the event run then applies it exactly once.
  try { document.addEventListener('bb:ad-config-loaded', run); } catch (e) {}
})();
